import { ChangeEvent, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setClaimNumber, setZipCode } from '../reducers/claimSlice/claimSlice';
import useClaimData from './useClaimData';
import Constants from '../../env/constants';
import { validateRegex } from '../reducers/actions';

export interface UseValidator {
    setClaimNumber: (e: ChangeEvent<HTMLInputElement>) => void;
    clearClaimNumber: VoidFunction;
    setZipCode: (e: ChangeEvent<HTMLInputElement>) => void;
    clearZipCode: VoidFunction;
    displayedClaimNumber: string | undefined;
    displayedZipCode: string | undefined;
    validateClaimNumber: VoidFunction;
}

export const useValidator = (): UseValidator => {
    const dispatch = useDispatch();
    const { claimNumber, zipCode } = useClaimData();
    // TODO: clear error message when text field cleared
    return useMemo(() => {
        return {
            validateClaimNumber: () => dispatch(validateRegex({ claimNumber, zipCode })),
            setClaimNumber: (e) => dispatch(setClaimNumber(e.target.value)),
            clearClaimNumber: () => {
                dispatch(setClaimNumber(''));
            },
            setZipCode: (e) => dispatch(setZipCode(e.target.value)),
            clearZipCode: () => dispatch(setZipCode('')),
            displayedClaimNumber: claimNumber === '' ? Constants.placeholderClaimNumber : undefined,
            displayedZipCode: zipCode === '' ? Constants.placeholderZipCode : undefined,
        };
    }, [claimNumber, zipCode]);
};
